import React, {useMemo} from "react"
import classNames from "classnames"

import {Remove} from "../Item"

import styles from "./Container.module.scss"
import {FormInput} from "../../../components/Form/FormInput"
import {UniqueIdentifier} from "@dnd-kit/core"
import {GoGrabber} from "react-icons/go"

export interface Props
{
    children: React.ReactNode;
    columns?: number;
    label?: string;
    style?: React.CSSProperties;
    horizontal?: boolean;
    hover?: boolean;
    handleProps?: React.HTMLAttributes<any>;
    scrollable?: boolean;
    shadow?: boolean;
    placeholder?: boolean;
    unstyled?: boolean;

    onClick?(): void;

    onRemove?(): void;

    id: UniqueIdentifier;
    values: any
    errors: any
    touched: any
    handleBlur: any
    handleChange: any
}

export const Container = React.memo(React.forwardRef<HTMLDivElement, Props>(
    (
        {
            id,
            children,
            columns = 1,
            handleProps,
            horizontal,
            hover,
            onClick,
            onRemove,
            label,
            placeholder,
            style,
            scrollable,
            shadow,
            unstyled,
            values,
            errors,
            touched,
            handleBlur,
            handleChange,
            ...props
        }: Props,
        ref,
    ) =>
    {
        const Component = onClick ? "button" : "div"

        const number = useMemo(() => id?.toString().replace("group", ""), [id])

        return (
            <Component
                {...props}
                type="button"
                //@ts-ignore
                ref={ref}
                style={
                    {
                        ...style,
                        "--columns": columns,
                    } as React.CSSProperties
                }
                className={classNames(
                    styles.Container,
                    unstyled && styles.unstyled,
                    horizontal && styles.horizontal,
                    hover && styles.hover,
                    placeholder && styles.placeholder,
                    scrollable && styles.scrollable,
                    shadow && styles.shadow,
                )}
                onClick={onClick}
                tabIndex={onClick ? 0 : undefined}
            >
                {label ? (
                    <div className={styles.Header}>
                        <GoGrabber size={20}
                                   {...handleProps}
                                   style={{minWidth: 20, cursor: "grab", marginRight: 10}}
                        />

                        <FormInput value={values[`value`]}
                                   placeholder="Группа"
                                   name={`${number}.value`}
                                   onBlur={handleBlur}
                                   onChange={handleChange}
                                   isInvalid={touched[`value`] && errors[`value`]}
                                   showErrorMessage={false}
                                   containerStyle={{width: "100%", marginBottom: 0}}
                                   allowClear
                                   disabled={number === "0"}
                        />

                        <div className={styles.Actions}>
                            {onRemove && number !== "0" ? <Remove onClick={onRemove}/> : undefined}
                        </div>
                    </div>
                ) : null}
                {placeholder ? children : <ul>{children}</ul>}
            </Component>
        )
    },
))
